import { zafClient } from '@/services/zendesk'
import type { ZafMetadata, VtexOrderListItem } from '@/interfaces'

export async function searchVtexOrders(q: string, incompleteOrders = false): Promise<VtexOrderListItem[]> {
  if (!zafClient) throw new Error('ZAF client not available')

  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const { vtexAppSubdominio, vtexAppKey, vtexAppToken } = meta.settings

  const response = await zafClient.request({
    url: `https://${vtexAppSubdominio}.vtexcommercestable.com.br/api/oms/pvt/orders/?q=${encodeURIComponent(q)}&incompleteOrders=${incompleteOrders}`,
    type: 'GET',
    headers: {
      'X-VTEX-API-AppKey': vtexAppKey,
      'X-VTEX-API-AppToken': vtexAppToken,
    },
    dataType: 'json',
  }) as { list: VtexOrderListItem[] }

  return response.list
}
